<template>
  <div class="img-item-content" :style="imgWidth" v-if="datamodel && datamodel.value">
    <img :src="src" alt="" height="200">
  </div>
  <div v-else></div>
</template>

<script>

export default {
  uuid: "00000000-0000-0000-0000-000000100005",
  components: {},
  props: [
    'datamodel',
    'inList',
    'imgWidth'
  ],
  data() {
    return {
      
    }
  },
  computed: {
    src() {
      return this.datamodel.value && this.datamodel.value.filelocation
    },
    // imgStyle() {
    //   return { ...this.imgWidth }
    // }
  },
  methods: {
    
  },
  created() {},
  mounted() {

  }
}
</script>
<style lang="scss">
.img-item-content {
  // width: calc(100vw - 80px);
  flex: 1;
  margin: 16px 31px;
  // padding: 0 31px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    object-fit: contain;
  }
}

</style>
